export const tutorOne2OneLoading =  ({store})  => store.tutorOne2OneReducer.loading;

export const tutorOne2OneError =  ({store})  => store.tutorOne2OneReducer.error;

export const tutorOne2OneData =  ({store})  => store.tutorOne2OneReducer.data;